import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";

import { Button, Input, Modal } from "../ui";

type CreateCampaignNameModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onNext?: (campaignName: string) => void;
  defaultName?: string;
};

const createCampaignNameSchema = yup.object({
  campaignName: yup.string().trim().required("Campaign name is required"),
});

export default function CreateCampaignNameModal({
  isOpen,
  onClose,
  onNext,
  defaultName = "Launchpad growth campaign",
}: CreateCampaignNameModalProps) {
  const formik = useFormik({
    initialValues: {
      campaignName: "",
    },
    validationSchema: createCampaignNameSchema,
    onSubmit: async (values) => {
      onNext?.(values.campaignName.trim());
    },
  });

  React.useEffect(() => {
    if (isOpen) {
      formik.resetForm();
    }
    // Reset only when modal opens to avoid clearing user typing on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="small"
      title="Create New Campaign"
      closeIconSrc="/icons/x_circle.svg"
      panelClassName="bg-white p-4"
      headerClassName="rounded-t-[12px]  border border-border-grey border-b-0 bg-white px-4 pt-3"
      titleClassName="text-md !font-medium"
      bodyClassName="rounded-b-[12px] border border-t-0 border-border-grey bg-white px-4 py-4"
    >
      <form className="space-y-4" onSubmit={formik.handleSubmit}>
        <Input
          label="New Campaign Name *"
          id="campaignName"
          name="campaignName"
          size="sm"
          value={formik.values.campaignName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            (formik.touched.campaignName || formik.submitCount > 0) &&
            typeof formik.errors.campaignName === "string"
              ? formik.errors.campaignName
              : ""
          }
          placeholder={defaultName}
        />
        <Button
          variant="primary"
          size="sm"
          fullWidth
          type="submit"
          isLoading={formik.isSubmitting}
        >
          {formik.isSubmitting ? "Checking..." : "Next"}
        </Button>
      </form>
    </Modal>
  );
}
